// 액션 타입 정의
const IMAGE_RESET = 'IMAGE_RESET';
const HASH = 'HASH';
const CURRENT_BRANCH_INDEX = 'CURRENT_BRANCH_INDEX';
const CURRENT_INDEX = 'CURRENT_INDEX';
const STAR_INDEX = 'STAR_INDEX';
const BG = 'BG';
const BG_IMAGE = 'BG_IMAGE';
const BG_COLOR = 'BG_COLOR';
const RADIUS = 'RADIUS';
const BG_IMAGE_BLUR = 'BG_IMAGE_BLUR';
const DEEPLINK = 'DEEPLINK';

// 액션 생섬함수 정의
export const imageReset = () => ({ type: IMAGE_RESET });
export const editHash = value => ({
  type: HASH,
  value
});
export const editCurrentBranchIndex = value => ({
  type: CURRENT_BRANCH_INDEX,
  value
});
export const editCurrentIndex = value => ({
  type: CURRENT_INDEX,
  value
});
export const editStarIndex = value => ({
  type: STAR_INDEX,
  value
});
export const editBg = value => ({
  type: BG,
  value
});
export const editBgImage = value => ({
  type: BG_IMAGE,
  value
});
export const editBgColor = value => ({
  type: BG_COLOR,
  value
});
export const editRadius = value => ({
  type: RADIUS,
  value
});
export const editBgImageBlur = value => ({
  type: BG_IMAGE_BLUR,
  value
});
export const editDeeplink = value => ({
  type: DEEPLINK,
  value
});

// 초기상태 정의
const initialState = {
  hash: null,
  currentBranchIndex: '',
  currentIndex: 0,
  starIndex: 2,
  bg: 'image',
  bgImage: {},
  bgColor: {},
  radius: {},
  bgImageBlur: {},
  deeplink: {}
};
// 리듀서 작성
export default function imageReducer(state = initialState, action) {
  switch (action.type) {
    case IMAGE_RESET:
      return initialState;
    case HASH:
      return {
        ...state,
        hash: action.value
      };
    case CURRENT_BRANCH_INDEX:
      return {
        ...state,
        currentBranchIndex: action.value
      };
    case CURRENT_INDEX:
      return {
        ...state,
        currentIndex: action.value
      };
    case STAR_INDEX:
      return {
        ...state,
        starIndex: action.value
      };
    case BG:
      return {
        ...state,
        bg: action.value
      };
    case BG_IMAGE:
      return {
        ...state,
        bgImage: action.value
      };
    case BG_COLOR:
      return {
        ...state,
        bgColor: action.value
      };
    case RADIUS:
      return {
        ...state,
        radius: action.value
      };
    case BG_IMAGE_BLUR:
      return {
        ...state,
        bgImageBlur: action.value
      };
    case DEEPLINK:
      return {
        ...state,
        deeplink: action.value
      };
    default:
      return state;
  }
}
